<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content" style="color: var(--theme-text-main);">
                        <slot />
                        <p class="h3 text-seccess fw-bold">Please login to get the authorization</p>
                        <label title="User Name">User Name</label>
                        <input type="text" v-on:keyup.enter="Void()" class="form-control" name="UserName" id="DeleteUserName" v-model="username"/>
                        <label title="Password">Password</label>
                        <input type="password" v-on:keyup.enter="Void()" class="form-control" name="Password" id="DeletePassword" v-model="password"/>
                        <br>
                        <table style="width:100%"> 
                            <tr> 
                                <td> 
                                </td> 
                                <td> 
                                    <button @click="Void()" class="btn btn-primary">Check For Permission</button>
                                </td> 
                                <td> 
                                    <button @click="close" class="btn btn-primary">Close</button>                                    
                                </td> 
                                <td> 
                                </td> 
                                <td> 
                                </td> 
                            </tr> 
                        </table>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>

import axios from "axios";
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    name:"Void",
    mounted() {
        this.$el.querySelector('#DeleteUserName').focus = true;
    }, 

    data: function(){
        return {
            username : '',
            password : '',
            authorizedToDeleteOrder : 'N',
            void_user_id: '',
        }
    },
    methods:{
        passDeleteOrderPermission()
        {
            this.username = '';
            this.password = '';
            this.$emit('getDeleteOrderPermission', this.authorizedToDeleteOrder)
        },
        passDeleteUser()
        {
            this.$emit('getDeleteUser', this.void_user_id)
        },
        
        Void: async function(){
            try{
                let dataURL = this.apiURL+'Users/checkForVoidPermision';
                let loginJson = {'action': 'login', 'username': this.username, "password" : this.password};
                let response = await axios.post(dataURL, loginJson); 
                if(response.data.void === true){
                    this.authorizedToDeleteOrder = 'Y';
                    this.void_user_id = response.data.id;
                    this.passDeleteUser();
                    this.passDeleteOrderPermission();
                    this.close();
                }else{
                    this.showAlert("Not Permitted! ");
                }
            }
            catch (error){
                console.log(error);
            }
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 10;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
.vue-modal-inner {
    max-width: 50%;
    max-height: 50%;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
